import React from "react"
import PropTypes from "prop-types"
import { withRadium, gtmEvent as withGtmEvent, DetectCompact } from "higher-order-components"
import { gtmMyMazda2ActionTypes } from "store/gtm-events"
import { Button } from "components"
import { H2 } from "AtomicComponents"
import { MyMazdaLogin } from "AtomicContainers"
import { BASE_COPY } from "constants/general-style"
import COLOR_PALETTE from "constants/color-palette"

const MyMazdaLoginContainer = ({
  compact, img, registerPageUrl, gtmEvent, createAccountButtonText, ...props
}) => (
  <div style={styles.wrapper}>
    {!compact && (
      <div style={styles.container(true, compact)}>
        <H2 withDetails>
         Create an account
        </H2>
        <div>
          <img
            style={styles.img}
            src={img || "/globalassets/mymazda/mazda-ownership2x.png"}
            alt="key" />
        </div>
        <p style={[styles.text, { marginTop: "1em" }]}>Own a Mazda? Create your account now.</p>
        <div style={{marginTop: "-1em"}}>
          <Button
            styleName="blackOutlined"
            type="a"
            href={registerPageUrl}
            display="block"
            gtmEvents={[createGtmAction.createAccount({ gtmEvent, createAccountButtonText })]}>
            {createAccountButtonText}
          </Button>
        </div>
      </div>
    )}
    <div style={styles.container2(false, compact)}>
      <MyMazdaLogin {...props} />
      {compact && (
        <div style={styles.register}>
          <p style={[styles.text, { marginTop: "2em" }]}>Own a Mazda? Create your account now.</p>
          <Button
            styleName="blackOutlined"
            type="a"
            href={registerPageUrl}
            display="block"
            gtmEvents={[createGtmAction.createAccount({ gtmEvent, createAccountButtonText })]} >
            {createAccountButtonText}
          </Button>
        </div>
      )}
    </div>
  </div>
)

MyMazdaLoginContainer.propTypes = {
  createAccountButtonText: PropTypes.string,
  compact: PropTypes.bool,
  img: PropTypes.string,
  registerPageUrl: PropTypes.string,
  gtmEvent: PropTypes.func
}

MyMazdaLoginContainer.defaultProps = {
  createAccountButtonText: "Create my account"
}

const createGtmAction = {
  createAccount: ({ gtmEvent, createAccountButtonText }) => ({
    func: gtmEvent,
    args: [
      {
        gtmID: gtmMyMazda2ActionTypes.CREATE_ACCOUNT,
        gtmPayload: { buttonText: createAccountButtonText }
      }
    ]
  })
}

export default withRadium(DetectCompact({ threshold: 920 }), withGtmEvent())(MyMazdaLoginContainer)

const styles = {
  wrapper: {
    color: COLOR_PALETTE.BLACK,
    marginTop: "8em",
    background: "#fff",
    display: "flex",
    padding: "2em 2em 0em 2em"
  },
  container: (border, compact) => ({
    background: "#fff",
    borderRight: border ? "1px solid #eee" : "0",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    margin: compact ? "0" : "3.2em 0",
    padding: compact ? "0" : "2.4em 6em",
    width: compact ? "100%" : "50%"
  }),
  container2: (border, compact) => ({
    background: "#fff",
    borderRight: border ? "1px solid #eee" : "0",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    padding: compact ? "0" : "4.1em 3em",
    width: compact ? "100%" : "50%"
  }),
  text: {
    ...BASE_COPY,
    marginBottom: "1em",
    textAlign: "center"
  },
  img: {
    display: "block",
    margin: "1em auto 0px",
    width: "70px"
  },
  register: {
    borderTop: "1px solid #eee",
    margin: "2em auto 0 auto",
    width: "100%",
    maxWidth: "24em"
  }
}



// WEBPACK FOOTER //
// ./src/containers/mymazda/login/index.jsx